import { render, staticRenderFns } from "./PicWall.vue?vue&type=template&id=9afc01e2&scoped=true&"
import script from "./PicWall.vue?vue&type=script&lang=ts&"
export * from "./PicWall.vue?vue&type=script&lang=ts&"
import style0 from "./PicWall.vue?vue&type=style&index=0&id=9afc01e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afc01e2",
  null
  
)

export default component.exports